import React from "react";
import { normalizeProps } from "./utils/normalizeProps";

const AltaIcon = (props) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...normalizeProps(props)}
    >
      <path
        d="M8.89141 0.01542C7.09383 0.110747 5.4432 0.618223 4.20078 1.45514C3.78813 1.73271 3.56102 2.02009 3.40516 2.46028C3.20625 3.02383 3.18695 3.82009 3.3532 4.5757C3.37102 4.6528 3.38438 4.7229 3.38438 4.73411C3.38438 4.74953 3.09641 4.75234 1.69219 4.75234H0V9.87617V15H9.5H19V9.87617V4.75234H17.3078C15.9036 4.75234 15.6156 4.74953 15.6156 4.73411C15.6156 4.7229 15.629 4.6528 15.6468 4.5757C15.8145 3.81869 15.7938 3.02523 15.5934 2.45607C15.439 2.02009 15.2104 1.73271 14.7992 1.45514C13.2703 0.424766 11.1061 -0.102337 8.89141 0.01542ZM10.168 1.66822C10.922 1.73271 11.6152 1.88271 12.2609 2.12243C12.6142 2.2542 13.0803 2.49252 13.4217 2.71963C13.8002 2.96916 14.0036 3.27056 14.1372 3.77944C14.204 4.03598 14.25 4.37663 14.25 4.62897V4.75234H9.5H4.75V4.62897C4.75 4.17617 4.86281 3.65187 5.03055 3.32103C5.19531 2.9972 5.3675 2.83598 5.87516 2.53318C6.06813 2.41822 6.5357 2.19813 6.76875 2.11262C7.29867 1.91776 7.90133 1.77336 8.47578 1.70467C8.62422 1.68645 8.85281 1.66682 9.12891 1.6486C9.27141 1.63878 9.98984 1.6528 10.168 1.66822ZM10.6281 7.86449V8.92991L11.7607 8.93271L12.8918 8.93692V10.0023V11.0678L11.7607 11.072L10.6281 11.0748V12.1402V13.2056H9.5H8.37188V12.1402V11.0748L7.24078 11.072L6.1082 11.0678V10.0023V8.93692L7.24078 8.93271L8.37188 8.92991V7.86449V6.79906H9.5H10.6281V7.86449Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default AltaIcon;
